import { z } from 'zod';

export interface CityApi {
  id: string;
  name: string;
  departmentId: string;
  createdAt?: string;
  updatedAt?: string;
  department?: {
    id: string;
    name: string;
    createdAt?: string;
    updatedAt?: string;
  };
}

export interface OfficeApi {
  id: string;
  name: string;
  description: string;
  address: string;
  cityId: string;
  createdAt?: string;
  updatedAt?: string;
  city?: CityApi;
}

export interface OfficesFilter {
  name?: string;
  cityId?: string;
}

export const officeSchema = z.object({
  name: z
    .string()
    .min(1, 'Debe ingresar un nombre')
    .max(100, 'El nombre no puede exceder 100 caracteres'),
  description: z
    .string()
    .max(500, 'La descripción no puede exceder 500 caracteres'),
  address: z
    .string()
    .min(1, 'Debe ingresar una dirección')
    .max(200, 'La dirección no puede exceder 200 caracteres'),
  cityId: z.string().min(1, 'Debe seleccionar una ciudad'),
});

export type OfficeSchema = z.infer<typeof officeSchema>;

export const defaultValues: OfficeSchema = {
  name: '',
  description: '',
  address: '',
  cityId: '',
};
